import { DropTarget } from 'react-dnd';
import { includes } from 'lodash/fp';
import { ItemTypes } from 'constants/itemTypes';

const ALLOWED_TYPES = 'question';
const NOT_ALLOWED_CONTENT_TYPES = 'webcam_recording screen_recording';

const questionBankTarget = {
  // On drop, the dragged element will have access to the target parent id
  drop(props, monitor, component) {
    return { parentId: props.id };
  },
  // Only elements of ALLOWED_TYPES that are not a child of the target parent
  // will be allowed to be dropped
  canDrop({ id }, monitor) {
    const { type, parent_id: childParentId, content } = monitor.getItem();
    const existingChild = id === childParentId;
    return (
      !existingChild &&
      includes(type, ALLOWED_TYPES) &&
      !includes(content.question_type, NOT_ALLOWED_CONTENT_TYPES)
    );
  },
};

const collect = (connector, monitor) => ({
  connectDropTarget: connector.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop(),
});

export default DropTarget([ItemTypes.ELEMENT], questionBankTarget, collect);
